/**
 * This module aims to provide an exhaustive extension of chakra-ui
 * theming with a general design principle of keeping variants
 * simplified
 *
 * @module
 */

import * as components from './components'
import * as tokens from './tokens'
import * as styles from './styles'

/**
 * Global chakra config
 */
const config = {
  cssVarPrefix: 'gaia',
}

/**
 * Default reading direction
 */
const direction = 'ltr'

/**
 * A custom Gaia chakra-ui theme - note here we are _not_ using
 * `extendTheme` as we explicitly want to control the size of the
 * generated css and only have themes we have provided
 *
 * @see https://chakra-ui.com/docs/styled-system/customize-theme
 */
export const theme = {
  ...tokens,
  ...styles,
  components,
  config,
  direction,
}
